// extracted by mini-css-extract-plugin
module.exports = {"container":"TabExternalAccess_container__1_m79","menuItemOptions":"TabExternalAccess_menuItemOptions__1iQPm","icon":"TabExternalAccess_icon__iXc2B"};